import { config } from '@uhg-abyss/web/tools/config';
import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { usePcpEmailEligibilityStore } from '../../store/usePcpEmailStore';
import {
  PcpEmailEligibilityState,
  STATUS,
} from '../../store/usePcpEmailStore/pcpEmailStore';
import { useCustomQuery } from '../useCustomQuery';
import GET_PCP_EMAIL from './PcpEmailEligibility.graphql';

export const usePcpEmailEligibility = () => {
  const {
    setPcpEmailEligibilityData,
    clearPcpEmailEligibilityData,
    setStatus,
  } = usePcpEmailEligibilityStore(
    useShallow((state: PcpEmailEligibilityState) => ({
      setPcpEmailEligibilityData: state.setPcpEmailEligibilityData,
      clearPcpEmailEligibilityData: state.clearPcpEmailEligibilityData,
      setStatus: state.setStatus,
    }))
  );
  const [queryResult, queryAction] = useCustomQuery(GET_PCP_EMAIL, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'pcpEmail',
    skip: true,
    onCompleted: (result) => {
      setPcpEmailEligibilityData(result?.data?.pcpEmailEligibility ?? {});
      setStatus(STATUS.SUCCESS);
    },
    onError: () => {
      clearPcpEmailEligibilityData();
      setStatus(STATUS.ERROR);
    },
  });

  const fetchPCPEligibility = useCallback(
    (options) => {
      setStatus(STATUS.LOADING);
      return queryAction(options);
    },
    [queryAction, setStatus]
  );

  return [queryResult, fetchPCPEligibility];
};
